module.exports = __webpack_public_path__ + "img/500px-light.51c8a039.svg";